import React from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';
import { getElementosHora, escolaridades } from "../../../resources/Helper";
import { buildCuestionarioSearch, withCuestionarioToken } from './cuestionarioPacienteHelpers';
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorPais from "../custom/SelectorPais";

function CuestionarioPaciente2() {
    
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [horaNacimiento, setHoraNacimiento] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [ciudadNacimiento, setCiudadNacimiento] = useState('');
    const [nombreCiudadExterior, setNombreCiudadExterior] = useState('');
    const [nombreOcupacion, setNombreOcupacion] = useState('');
    const [escolaridad, setEscolaridad] = useState('');
    const [componenteHoraNacimiento, setComponenteHoraNacimiento] = useState('12');
    const [componenteMinutoNacimiento, setComponenteMinutoNacimiento] = useState('00');
    const [componenteAmpmNacimiento, setComponenteAmpmNacimiento] = useState('pm');
    const [discapacidad, setDiscapacidad] = useState('08');
    const [etnia, setEtnia] = useState('');

    const queryParams = useLocation().search;
    const qsInit = new URLSearchParams(queryParams);

    const [idPaciente] = useState(qsInit.get('id'));
    const [tokenPaciente] = useState(qsInit.get('token'));
    const [logoClienteUrl, setLogoClienteUrl] = useState(null);

    const [errorlist, setErrorlist] = useState({});
    const [headerCollapsed, setHeadercollapsed] = useState('collapse-hdr');
    const [loading, setLoading] = useState();

    const [idPaisNacimiento, setIdPaisNacimiento] = useState();
    const [idCiudadNacimiento, setIdCiudadNacimiento] = useState();



    // variables para consulta de pais de nacimiento
    const [resultadosPaises, setResultadosPaises] = useState([]);
    const [resultadosPaisesState, setResultadosPaisesState] = useState('');
    const [deshabilitarInputPais, setDeshabilitarInputPais] = useState(false);
    const [btnEliminarPaisVisible, setBtnEliminarPaisVisible] = useState('hide');

    // variables para consulta de ciudad de nacimiento
    const [resultadosCiudadesNacimiento, setResultadosCiudadesNacimiento] = useState([]);
    const [resultadosCiudadesNacimientoState, setResultadosCiudadesNacimientoState] = useState('');
    const [habilitarCiudadNacimiento, setHabilitarCiudadNacimiento] = useState(false);
    const [btnEliminarCiudadNacimientoVisible, setBtnEliminarCiudadNacimientoVisible] = useState('hide');



    let history = useHistory();




    useEffect(() => {

        const config = {
            params: {
                id: idPaciente,
                token: tokenPaciente || undefined,
            }
        }

        axios.get('/paciente-publico',config)
            .then(response => {
                setEstadoCivil(response.data[0].estado_civil);
                setFechaNacimiento(response.data[0].fecha_nacimiento);

                setPaisNacimiento(response.data[0].nombre_pais_nacimiento);
                setIdPaisNacimiento(response.data[0].id_pais_nacimiento);

                setIdCiudadNacimiento(response.data[0].id_ciudad_nacimiento);
                setCiudadNacimiento(response.data[0].nombre_ciudad_nacimiento);

                setLogoClienteUrl(response.data[0].logo_cliente_url || null);

                setNombreOcupacion(response.data[0].nombre_ocupacion || '');
                setEscolaridad(response.data[0].escolaridad);
                setEtnia(response.data[0].etnia);

                if (response.data[0].discapacidad) {
                    setDiscapacidad(response.data[0].discapacidad);
                }

                if (response.data[0].id_ciudad_nacimiento!=null) {
                    setHabilitarCiudadNacimiento(true);
                    setBtnEliminarCiudadNacimientoVisible('');
                }
                else {
                    setHabilitarCiudadNacimiento(false);
                    setBtnEliminarCiudadNacimientoVisible('hide');
                }

                
                if (response.data[0].id_pais_nacimiento!=null) {
                    setDeshabilitarInputPais(true);
                    setBtnEliminarPaisVisible('');
                }
                else {
                    setDeshabilitarInputPais(false);
                    setBtnEliminarPaisVisible('hide');
                }

                if (response.data[0].hora_nacimiento) {
                    let componentesHoraNacimiento = getElementosHora(response.data[0].hora_nacimiento);
                    setComponenteHoraNacimiento(componentesHoraNacimiento[0]);
                    setComponenteMinutoNacimiento(componentesHoraNacimiento[1]);
                    setComponenteAmpmNacimiento(componentesHoraNacimiento[2]);
                }

            })
            .catch(error => {
                console.log(error);
            })
    }, [idPaciente, tokenPaciente]);






    const agregarPaisNacimiento = (id,nombrePais) => {
        
        // Se asigna el id del pais de nacimiento
        setIdPaisNacimiento(id);
        // Se ocultan los resultados de la búsqueda
        setResultadosPaisesState('');
        // Se llena el campo 'Ciudad de nacimiento'
        document.getElementById('paisNacimiento').value = nombrePais;
        // Se deshabilita el campo 'Ciudad de nacimiento'
        setDeshabilitarInputPais(true);
        // Se muestra el botón para eliminar la selección de ciudad de nacimiento
        setBtnEliminarPaisVisible('');
    }

    const eliminarPaisNacimiento = () => {

        setIdPaisNacimiento(null);
        document.getElementById('paisNacimiento').value = '';
        setDeshabilitarInputPais(false);
        setBtnEliminarPaisVisible('hide');
        document.getElementById('paisNacimiento').focus();
    }

    const buscarPaisNacimiento = (e) => {

        if (e.length>2) {

            const config = {
                params: {
                    term: e,
                    paciente_id: idPaciente,
                    token: tokenPaciente || '',
                }
            };
    
            axios.get('/pais-cuestionario', config)
                .then(response => {
    
                    if (response.status===200) {
                        
                        response.data.length>0 ? setResultadosPaisesState('visible') : setResultadosPaisesState('');
                        setResultadosPaises(response.data);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                });
        }
    }








    const agregarCiudadNacimiento = (id,nombreCiudad,nombreDepto) => {

        // Se asigna el id de la ciudad de nacimiento
        setIdCiudadNacimiento(id);
        // Se ocultan los resultados de la búsqueda
        setResultadosCiudadesNacimientoState('');
        // Se llena el campo 'Ciudad de nacimiento'
        //setCiudadNacimiento(nombreCiudad+', '+nombreDepto);
        document.getElementById('ciudadNacimiento').value = nombreCiudad+', '+nombreDepto;
        // Se deshabilita el campo 'Ciudad de nacimiento'
        setHabilitarCiudadNacimiento(true);
        // Se muestra el botón para eliminar la selección de ciudad de nacimiento
        setBtnEliminarCiudadNacimientoVisible('');
    }

    const eliminarCiudadNacimiento = () => {
        
        setIdCiudadNacimiento(null);
        document.getElementById('ciudadNacimiento').value = '';
        setHabilitarCiudadNacimiento(false);
        setBtnEliminarCiudadNacimientoVisible('hide');
        document.getElementById('ciudadNacimiento').focus();
    }

    const buscarCiudadNacimiento = (e) => {

        setNombreCiudadExterior(e);

        if (e.length>2) {

            const config = {
                params: {
                    term: e,
                    paciente_id: idPaciente,
                    token: tokenPaciente || '',
                }
            };
    
            axios.get('/ciudad-cuestionario', config)
                .then(response => {
    
                    if (response.status===200) {
                        
                        response.data.length>0 ? setResultadosCiudadesNacimientoState('visible') : setResultadosCiudadesNacimientoState('');
                        setResultadosCiudadesNacimiento(response.data);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                });
        }
    }
























    const handleSubmit = (e) => {
        e.preventDefault();

        let hnc = (componenteAmpmNacimiento=='pm'&&parseInt(componenteHoraNacimiento)<12) ? parseInt(componenteHoraNacimiento)+12 : componenteHoraNacimiento;

        let hn = hnc+':'+componenteMinutoNacimiento;

        const config = {
            id:idPaciente,
            estado_civil: estadoCivil,
            fecha_nacimiento: fechaNacimiento,
            hora_nacimiento: hn,
            ciudad_nacimiento: idCiudadNacimiento,
            nombre_ciudad_exterior: nombreCiudadExterior,
            ocupacion: nombreOcupacion,
            nombre_ocupacion: nombreOcupacion,
            escolaridad: escolaridad,
            nacionalidad: idPaisNacimiento,
            pais_nacimiento: idPaisNacimiento,
            componente_hora_nacimiento: componenteHoraNacimiento,
            componente_minuto_nacimiento: componenteMinutoNacimiento,
            componente_ampm_nacimiento: componenteAmpmNacimiento,
            discapacidad: discapacidad,
            etnia: etnia
        }

        axios.put('/datos-personales2-publico', withCuestionarioToken(config, tokenPaciente))
            .then(response => {
                setLoading(false);
                history.push({
                    pathname: '/cuestionario-paciente3',
                    search: buildCuestionarioSearch(idPaciente, tokenPaciente)
                });
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })
    }

    return (
                
                <div className="contenedor-cuestionario">

                    <div style={{textAlign:'center'}}>
                        <img
                            src={logoClienteUrl || logo}
                            alt={logoClienteUrl ? 'Logo clínica' : 'Smile software'}
                            style={{ maxWidth: 220, maxHeight: 88, objectFit: 'contain' }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = logo;
                                e.currentTarget.alt = 'Smile software';
                            }}
                        />
                    </div>

                    <div className="row mb-2" style={{marginTop:'30px'}}>
                        <h1 className="m-0" style={{textAlign: 'center', width: '100%'}}>Información personal</h1>
                    </div>

                    <div className="indicador-progreso">
                        <div className="indicador-punto completado">1</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">2</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">3</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">4</div>
                    </div>

                    <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">
                        
                        <div className="card cuestionario-paciente">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <a className="d-block w-100" data-toggle="collapse" data-target="#infobasica" href="#" style={{textAlign:'center'}}>
                                        Datos Personales
                                    </a>
                                </h4>
                            </div>
                            <div id="infobasica" className="collapse show">
                                <div className="card-body">

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="estadoCivil">Estado civil <span className="text-danger">*</span></label>
                                                <select name="tipo-sangre" className="form-control" id="estadoCivil" value={estadoCivil} onChange={(e) => setEstadoCivil(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="soltero">SOLTERO</option>
                                                    <option value="casado">CASADO</option>
                                                    <option value="union_libre">UNIÓN LIBRE</option>
                                                    <option value="viudo">VIUDO</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist?.estado_civil}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="fechaNacimiento">Fecha de nacimiento <span className="text-danger">*</span></label>
                                                <input type="date" name="fecha-nacimiento" className="form-control" id="fechaNacimiento" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist?.fecha_nacimiento}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="horaNacimiento">Hora de nacimiento <span className="text-danger">*</span></label>
                                                
                                                <div className="control-hora">
                                                    <select className="form-control" value={componenteHoraNacimiento} onChange={(e) => setComponenteHoraNacimiento(e.target.value)}>
                                                        <option value=""></option>
                                                        <option value="00">00</option>
                                                        <option value="01">01</option>
                                                        <option value="02">02</option>
                                                        <option value="03">03</option>
                                                        <option value="04">04</option>
                                                        <option value="05">05</option>
                                                        <option value="06">06</option>
                                                        <option value="07">07</option>
                                                        <option value="08">08</option>
                                                        <option value="09">09</option>
                                                        <option value="10">10</option>
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                    </select>
                                                    <select className="form-control" value={componenteMinutoNacimiento} onChange={(e) => setComponenteMinutoNacimiento(e.target.value)}>
                                                        <option value=""></option>
                                                        <option value="00">00</option>
                                                        <option value="15">15</option>
                                                        <option value="30">30</option>
                                                        <option value="45">45</option>
                                                    </select>
                                                    <select className="form-control" value={componenteAmpmNacimiento} onChange={(e) => setComponenteAmpmNacimiento(e.target.value)}>
                                                        <option value=""></option>
                                                        <option value="am">AM</option>
                                                        <option value="pm">PM</option>
                                                    </select>
                                                </div>

                                                <div className="invalid-feedback visible">
                                                {errorlist?.componente_hora_nacimiento}
                                                {errorlist?.componente_minuto_nacimiento}
                                                {errorlist?.componente_ampm_nacimiento}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="paisNacimiento">País de nacimiento <span className="text-danger">*</span></label>
                                                <SelectorPais
                                                    value={idPaisNacimiento}
                                                    onChange={setIdPaisNacimiento}
                                                    cuestionarioPacienteId={idPaciente}
                                                    cuestionarioToken={tokenPaciente}
                                                />
                                                <div className="invalid-feedback visible">
                                                {errorlist?.pais_nacimiento}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="ciudadNacimiento">Ciudad de nacimiento</label>
                                                <SelectorCiudad
                                                    value={idCiudadNacimiento}
                                                    onChange={setIdCiudadNacimiento}
                                                    placeholder="Seleccione ciudad de nacimiento"
                                                    cuestionarioPacienteId={idPaciente}
                                                    cuestionarioToken={tokenPaciente}
                                                />
                                                <div className="invalid-feedback visible">
                                                {errorlist?.ciudad_nacimiento}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="ocupacion">Ocupación</label>
                                                <input 
                                                    type="text" 
                                                    name="ocupacion" 
                                                    className="form-control" 
                                                    id="ocupacion" 
                                                    value={nombreOcupacion} 
                                                    onChange={(e) => setNombreOcupacion(e.target.value)}
                                                />
                                                <div className="invalid-feedback visible">
                                              
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="escolaridad">Escolaridad</label>
                                                <select name="escolaridad" className="form-control" id="escolaridad" value={escolaridad} onChange={(e) => setEscolaridad(e.target.value)}>
                                                    <option></option>
                                                    {
                                                        escolaridades.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)
                                                    }
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist?.escolaridad}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="discapacidad">Discapacidad <span className="text-danger">*</span></label>
                                                <select name="discapacidad" className="form-control" id="discapacidad" value={discapacidad} onChange={(e) => setDiscapacidad(e.target.value)}>
                                                    <option value="01">FÍSICA</option>
                                                    <option value="02">VISUAL</option>
                                                    <option value="03">AUDITIVA</option>
                                                    <option value="04">INTELECTUAL</option>
                                                    <option value="05">SICOSOCIAL (MENTAL)</option>
                                                    <option value="06">SORDOCEGUERA</option>
                                                    <option value="07">MULTIPLE</option>
                                                    <option value="08">NINGUNA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="etnia">Etnia</label>
                                                <select name="etnia" className="form-control" id="etnia" value={etnia} onChange={(e) => setEtnia(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="99">NINGUNA DE LAS ANTERIORES</option>
                                                    <option value="01">INDIGENA</option>
                                                    <option value="02">ROM (GITANO)</option>
                                                    <option value="03">RAIZAL</option>
                                                    <option value="04">PALENQUERO</option>
                                                    <option value="05">NEGRO</option>
                                                    <option value="06">AFROCOLOMBIANO</option>
                                                    
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist?.etnia}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <button type="submit" className="btn btn-primary" style={{margin: '0 auto', fontSize: '1.4rem'}}>
                                Continuar&nbsp;
                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                            </button>
                        </div>
                    </form>
                </div>
    );
}
export default CuestionarioPaciente2;